import { render, staticRenderFns } from "./form_detail_companies_component.vue?vue&type=template&id=42bf75f6&scoped=true"
import script from "./form_detail_companies_component.vue?vue&type=script&lang=js"
export * from "./form_detail_companies_component.vue?vue&type=script&lang=js"
import style0 from "./form_detail_companies_component.vue?vue&type=style&index=0&id=42bf75f6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bf75f6",
  null
  
)

export default component.exports